import { background, position, textDecoration } from "@chakra-ui/react";

export default {
    parts: [],
    baseStyle: {
        /* General styling */
        container: {
            width: { lg: '100%' },
            maxWidth: { lg: 'container.xxxl' },
            margin: { lg: '0 auto' },
            paddingLeft: { lg: 6 },
            paddingRight: { lg: 6 }
        },
        contentWrapper: {
            paddingLeft: { base: 4, lg: 0 },
            paddingRight: { base: 4, lg: 0 }
        },
        heading: {
            marginTop: { base: 8, lg: '30px' },
            marginBottom: { base: 8, lg: '38px' },
            fontSize: { base: 'xl', lg: '2xl' },
            fontWeight: { base: 'bold' },
            textTransform: { base: 'uppercase' }
        },
        inputWrapper: {
            paddingBottom: { base: 8, lg: 2 },
            paddingLeft: { lg: 2 }
        },
        tab: {
            padding: { base: '0 0 8px' },
            fontSize: { base: 'sm' },
            lineHeight: { base: '100%' },
            marginLeft: { base: 4 },
            marginRight: { base: 4 },
            borderBottom: '2px solid',
            borderColor: 'transparent',
            _selected: {
                fontWeight: 'medium',
                color: 'black',
                borderColor: 'inherit',
                borderBottom: '2px solid',
                mb: '-2px',
                backgroundColor: 'white'
            }
        },
        storesTabPanel: {
            paddingTop: { base: 4 },
            paddingBottom: { base: 4 },
            paddingLeft: { base: 0 },
            paddingRight: { base: 0 }
        },
        mapTabPanel: {
            position: 'relative',
            padding: { base: 0 }
        },
        desktopLayout: {
            display: { lg: 'flex' },
            flexWrap: { lg: 'no-wrap' },
            gap: { lg: 4 },
            height: { lg: '670px' },
            marginBottom: { lg: '128px' }
        },
        mapContainer: {
            flex: { lg: '1' }
        },
        storesContainer: {
            display: { lg: 'flex' },
            flexDirection: { lg: 'column' },
            flex: { lg: '0 0 435px' },
            width: { lg: '100%' },
            maxWidth: { lg: '435px' }
        },
        inputAndNoStores: {
            flexShrink: { base: 0 }
        },
        storeListWrapper: {
            flex: 1,
            overflow: 'auto'
        },
        greenDot: {
            display: 'inline-block',
            width: '5px',
            height: '6px',
            backgroundColor: 'successText',
            marginRight: '6px'
        },
        redDot: {
            display: 'inline-block',
            width: '5px',
            height: '6px',
            backgroundColor: 'dangerText',
            marginRight: '6px'
        },
        hours: {
            display: 'flex',
            alignItems: 'center',
            fontSize: { base: 'xs' },
            lineHeight: { base: '15px' }
        },
        /* Components */
        components: {
            inputStyling: {
                container: {
                    position: 'relative'
                },
                icon: {
                    position: 'absolute',
                    left: 0,
                    top: '12px',
                },
                inputField: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                    paddingLeft: { base: 9 },
                    paddingRight: { base: 4 }
                },
                results: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                },
                stores: {
                    paddingTop: { base: 3 },
                    textOverflow: {base: 'ellipsis'},
                    whiteSpace: {base: 'nowrap'},
                    overflow: {base: 'hidden'}
                },
                geolocation: {
                    display: 'flex',
                    fontSize: {base: 'sm'},
                    lineHeight: {base: '18px'},
                    fontWeight: {base: 'normal'},
                    alignItems: 'center',
                    flex: { base: '0 0 auto' },
                    marginLeft: { base: 4 },
                    marginTop: { base: 2 },
                    cursor: { base: 'pointer' },
                    height: 'unset'
                },
                geoIcon: {
                    marginRight: { base: 1 }
                },
                geoError: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                    padding: { base: 4 },
                    backgroundColor: { base: 'alternativeWarning.100' },
                    color: { base: 'warningText' },
                    marginTop: { base: 6 }
                }
            },
            noResults: {
                container: {
                    marginTop: { lg: 6 },
                    marginBottom: { base: 8 },
                    paddingLeft: { lg: 2 }
                },
                title: {
                    fontSize: { base: 'md' },
                    lineHeight: { base: '20px' },
                    fontWeight: { base: 'bold' },
                    marginBottom: { base: 4 },
                    textTransform: { base: 'uppercase' }
                },
                subTitle: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                    marginBottom: { base: 6 }
                },
                cta: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '100%' },
                    padding: { base: 3 },
                    letterSpacing: { base: '2%' },
                    minWidth: { base: '113px' },
                    height: { base: 'auto' },
                    _hover: {
                        textDecoration: 'none'
                    }
                }
            },
            storeCard: {
                container: {
                    position: 'relative',
                    cursor: 'pointer',
                    paddingLeft: { base: 4, lg: 2 },
                    paddingRight: { base: 4, lg: 0 }
                },
                wrapper: {
                    paddingTop: { base: 4 },
                    borderBottom: '1px solid',
                    borderColor: 'black'
                },
                cardHeading: {
                    display: 'flex',
                    flexWrap: 'no-wrap',
                    alignItems: 'center',
                    marginBottom: { base: 2 }
                },
                nameAndDistance: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flex: 1,
                    paddingBottom: { base: 1 }
                },
                name: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '16px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    paddingRight: { base: 4 }
                },
                distance: {
                    fontSize: { base: 'xs' },
                    lineHeight: { base: '15px' },
                    paddingRight: { base: 1 }
                },
                addressWrapper: {
                    marginBottom: { base: 4 }
                },
                address: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                },
                hoursWrapper: {
                    paddingBottom: { base: 4 }
                }
            },
            storeDetails: {
                drawerCloseIcon: {
                    position: 'absolute',
                    width: { base: '24px' },
                    height: { base: '24px' },
                    top: { base: '16px' },
                    right: { base: '16px' },
                    minWidth: { base: 'auto' },
                    zIndex: '2',
                    backgroundColor: 'transparent',
                    _hover: {
                        backgroundColor: 'transparent'
                    },
                    color: 'black'
                },
                drawerContent: {
                    maxWidth: { lg: '483px' }
                },
                drawerBody: {
                    padding: { base: '72px 16px 32px', lg: '80px 24px 24px' }
                },
                blockSpacing: {
                    marginBottom: { base: 12, lg: 8 }
                },
                name: {
                    fontSize: { base: 'md' },
                    lineHeight: { base: '20px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    marginBottom: { base: 2 }
                },
                address: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' }
                },
                title: {
                    fontSize: { base: 'md' },
                    lineHeight: { base: '20px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    marginBottom: { base: 2 }
                },
                ctas: {
                    display: 'flex',
                    flexWrap: 'no-wrap',
                    gap: 2,
                    marginTop: { base: 4 }
                },
                cta: {
                    fontSize: 'md',
                    lineHeight: '20px',
                    padding: '13px 0',
                    height: 'auto',
                    width: '100%',
                    _hover: {
                        textDecoration: 'none'
                    }
                },
                content: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' }
                },
                statusWrapper: {
                    display: { lg: 'flex' },
                    justifyContent: { lg: 'space-between' },
                    marginTop: { lg: 2 }
                },
                getDirections: {
                    fontSize: { lg: 'sm' },
                    fontWeight: { lg: 'bold' },
                    textTransform: { lg: 'uppercase' },
                }
            }
        }
    }
}
